var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    fill: "#BBDEFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#2196F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2223_6593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 5H6.25C5.91848 5 5.60054 5.1317 5.36612 5.36612C5.1317 5.60054 5 5.91848 5 6.25V13.3333H7.875L9.46167 14.6742C9.61208 14.8013 9.80265 14.871 9.99958 14.871C10.1965 14.871 10.3871 14.8013 10.5375 14.6742L12.125 13.3333H15V6.25C15 5.91848 14.8683 5.60054 14.6339 5.36612C14.3995 5.1317 14.0815 5 13.75 5ZM14.1667 12.5H11.8192L10 14.0375L8.18083 12.5H5.83333V6.25C5.83333 6.13949 5.87723 6.03351 5.95537 5.95537C6.03351 5.87723 6.13949 5.83333 6.25 5.83333H13.75C13.8605 5.83333 13.9665 5.87723 14.0446 5.95537C14.1228 6.03351 14.1667 6.13949 14.1667 6.25V12.5Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7.08333H7.5V7.91666H10V7.08333Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.75H7.5V9.58333H12.5V8.75Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.4167H7.5V11.25H12.5V10.4167Z",
    fill: "#2196F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2223_6593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewComment);
export default __webpack_public_path__ + "static/media/NewComment.ef66ef67.svg";
export { ForwardRef as ReactComponent };